var path = 'app/scripts/modules/amazon/src/serverGroup/configure/wizard/instanceType/instanceType.html';
var html = "<div ng-if=\"!!(command.viewState.disableImageSelection || command.amiName)\">\n  <v2-instance-archetype-selector command=\"command\"></v2-instance-archetype-selector>\n  <div style=\"padding: 0 15px\">\n    <v2-instance-type-selector ng-if=\"command.viewState.instanceProfile && command.viewState.instanceProfile !== 'custom'\" command=\"command\"></v2-instance-type-selector>\n  </div>\n</div>\n<h5 class=\"text-center\"\n    ng-if=\"!command.amiName && !command.viewState.disableImageSelection\">Please select an image.</h5>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/scripts/modules/amazon/src/serverGroup/configure/wizard/instanceType/instanceType.html
// module id = 1241
// module chunks = 0